'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _reactIntl = require('react-intl');

var _date_formatter = require('common-utilities/src/date_formatter');

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentaryCard = function (_React$PureComponent) {
  _inherits(CommentaryCard, _React$PureComponent);

  function CommentaryCard() {
    _classCallCheck(this, CommentaryCard);

    return _possibleConstructorReturn(this, (CommentaryCard.__proto__ || Object.getPrototypeOf(CommentaryCard)).apply(this, arguments));
  }

  _createClass(CommentaryCard, [{
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'div',
        { className: '' },
        !(0, _ramda.isNil)(this.props.htmlCommentaries.topLine) && !(0, _ramda.isNil)(this.props.htmlCommentaries.asOfDateForCommentary) && _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: _string_utility2.default.renderFormattedLabel("Topline", "pdp-commentary-topline"),
            headerTitleId: "header-pdpCardTopline",
            headerTitleLable: "",
            disclosureText: this.props.disclosures.pdpCardTopline,
            placementId: "pdpCardTopLine",
            headerLabel: _react2.default.createElement(
              'span',
              { 'data-testid': 'commentary-as-of-date',
                className: 'text-left text-muted  font-light disclaimer font-warm-grey' },
              _string_utility2.default.renderFormattedLabel("As of ", "label-for-as-of"),
              ' ',
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'date-format', defaultMessage: this.props.htmlCommentaries.asOfDateForCommentary, values: (0, _date_formatter.formattedDateValObj)(this.props.htmlCommentaries.asOfDateForCommentary, false) })
            )
          },
          _react2.default.createElement(
            'div',
            { className: 'padding-top-10' },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'topline-commentary' },
              _react2.default.createElement('div', { className: 'ul',
                dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(!(0, _functional_utility.isNilOrEmpty)(this.props.htmlCommentaries.topLine) ? this.props.htmlCommentaries.topLine.replaceAll("COMBODYTEXT", "p") : null) } })
            )
          )
        ),
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: _string_utility2.default.renderFormattedLabel(this.props.htmlCommentaries.commentaryType, _constants2.default.getCommentaryType(this.props.htmlCommentaries.commentaryType)),
            headerTitleId: "header-pdpCardInReview",
            headerTitleLabel: "",
            disclosureText: this.props.disclosures.pdpCardInReview,
            placementId: "pdpCardInReview",
            headerLabel: !(0, _ramda.isNil)(this.props.htmlCommentaries.asOfDateForCommentary) && _react2.default.createElement(
              'span',
              { 'data-testid': 'commentary-as-of-date',
                className: 'text-left text-muted  font-light disclaimer font-warm-grey' },
              _string_utility2.default.renderFormattedLabel("As of ", "label-for-as-of"),
              ' ',
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'date-format', defaultMessage: this.props.htmlCommentaries.asOfDateForCommentary, values: (0, _date_formatter.formattedDateValObj)(this.props.htmlCommentaries.asOfDateForCommentary, false) })
            )
          },
          !(0, _ramda.isNil)(this.props.htmlCommentaries.inReview) && _react2.default.createElement(
            'div',
            { className: 'padding-top-10' },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'quarter-in-review-commentary' },
              _react2.default.createElement('ul', { className: 'ul-commentary',
                dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.htmlCommentaries.inReview) } })
            )
          )
        ),
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: _string_utility2.default.renderFormattedLabel("Looking Ahead", "pdp-commentary-looking-ahead"),
            headerTitleId: "header-pdpCardLookingAhead",
            headerTitleLabel: "",
            disclosureText: this.props.disclosures.pdpCardLookingAhead,
            placementId: "pdpCardLookingAhead",
            headerLabel: !(0, _ramda.isNil)(this.props.htmlCommentaries.asOfDateForCommentary) && _react2.default.createElement(
              'span',
              { 'data-testid': 'looking-ahead-as-of-date',
                className: 'text-left text-muted  font-light disclaimer font-warm-grey' },
              _string_utility2.default.renderFormattedLabel("As of ", "label-for-as-of"),
              ' ',
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'date-format', defaultMessage: this.props.htmlCommentaries.asOfDateForCommentary, values: (0, _date_formatter.formattedDateValObj)(this.props.htmlCommentaries.asOfDateForCommentary, false) })
            )
          },
          !(0, _ramda.isNil)(this.props.htmlCommentaries.lookingAhead) && _react2.default.createElement(
            'div',
            { className: 'padding-top-10' },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'looking-ahead-commentary' },
              _react2.default.createElement('ul', { className: 'ul-commentary',
                dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.htmlCommentaries.lookingAhead) } })
            )
          )
        )
      );
    }
  }]);

  return CommentaryCard;
}(_react2.default.PureComponent);

exports.default = CommentaryCard;